import React from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Print from "@material-ui/icons/PrintOutlined";
import ReactToPrint from "react-to-print";
import appConstant from "../../appConstants";
import Events from "../../utilities/EventEmitter";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  paper: {
    maxHeight: "300px",
    backgroundColor: theme.ModalBGColor
  },
  menuItemText: {
    fontSize: "12px",
    padding: "8px",
    color: theme.ColumnHeaderTextColor,
    fontWeight: 600
  }
});

class PrintMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };
  }

  handleClick = event => {
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl: null
    });
  };
  printLoadingManifest = () => {
    Events.emit("PublishNPrint");
    this.handleClose();
  };

  render() {
    const { classes } = this.props;
    const printFeatureFlag = this.props.featureFlags.find(ele=> ele.id=="PrintLoadingManifest");
    let showPrintLoadingManifest = false;
    if(printFeatureFlag && printFeatureFlag.value){
      showPrintLoadingManifest= true
    }
    const { anchorEl } = this.state;
    const routesMapContainer = this.props.stack.parent.getItemsById(
      appConstant.layout.RoutesMap
    );
    return (
      <div title="Print">
        <Print onClick={this.handleClick} />
        <Menu
          getContentAnchorEl={null}
          disableAutoFocusItem={true}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          classes={{ paper: classes.paper }}
          MenuListProps={{ disablePadding:true }}
        >
          {showPrintLoadingManifest && <MenuItem
            classes={{ root: classes.menuItemText }}
            onClick={this.printLoadingManifest}
          >
            Loading Manifest
          </MenuItem>}
          <div onClick={this.handleClose}>
            <ReactToPrint
              trigger={() => (
                <MenuItem classes={{ root: classes.menuItemText }}>
                  Route Map
                </MenuItem>
              )}
              content={() => routesMapContainer[0].element[0]} // not able get element in any other way
              copyStyles={true}
              onAfterPrint={this.props.onAfterPrint}
            />
          </div>
        </Menu>
      </div>
    );
  }
}

export default withStyles(styles)(PrintMenu);
